module.exports = __webpack_public_path__ + "img/subscriptions.a8bfaefc.svg";